import Vue from 'vue'
import Vuex from 'vuex'

import user from './modules/user';
import subscribes from './modules/subscribes';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
  },
  mutations: {
  },
  actions: {
  },
  modules: {
    user,
    subscribes
  }
})
